import { Trans } from '@lingui/react'
import { bool, number, oneOf, shape, string } from 'prop-types'

import { DOCUMENT_TYPE } from 'shared/consts'
import { AVAILABLE_PRESCRIPTION_TYPES } from 'shared/consts/productTemplates'
import { isSaeOnly } from 'shared/experiments/utils/featureFlags'
import Form from 'views/components/atoms/Form'
import IconCart from 'views/components/atoms/Icon/IconCart'
import ButtonWithIcon from 'views/components/molecules/ButtonWithIcon'
import withMountPoints from 'views/enhancers/withMountPoints'
import { isProductAvailable } from 'views/utils/productUtils'
import { mountPointsType, StockStatusType } from 'views/utils/propTypes'
import {
  usePageProperties,
  usePublicConfig,
} from 'views/utils/shopAndRuntimeConfigUtils'

const CartForm = ({
  mobile,
  prescriptionType,
  productId,
  algoliaQueryId,
  position,
  showProductDetailLink,
  stockStatus,
  offerId,
  mountPoints,
}) => {
  const isAvailable = isProductAvailable(stockStatus)
  const iconButtonParams = {}

  if (!showProductDetailLink) {
    iconButtonParams.style = 'buttonGhost'
  }

  const { tenant } = usePublicConfig()
  const { experiments } = usePageProperties()

  return (
    <Form
      name={`buy-product-from-${productId}-${mobile ? 'mobile' : 'laptop'}`}
      action={mountPoints.getAddToCart()}
      data-clientside-hook="chargeUrlSearchParams add2CartForm"
      data-qa-id="add-to-cart-button"
      className="o-FilteredProductListItem__ProductAction__CartForm"
    >
      <input name="cartAction" type="hidden" value="add" />
      <input name="product" type="hidden" value={productId} />
      <input name="eventType" type="hidden" value="conversion" />
      <input name="eventName" type="hidden" value="addToCart_ProductFilter" />
      <input name="quantity" type="hidden" value="1" />
      <input name="prescriptionType" type="hidden" value={prescriptionType} />
      {algoliaQueryId && (
        <input name="queryID" type="hidden" value={algoliaQueryId} />
      )}
      {
        // item position in search result page
        Boolean(position) && (
          <input name="position" type="hidden" value={position} />
        )
      }
      {isSaeOnly(experiments, tenant) && (
        <input name="offer" type="hidden" value={offerId} />
      )}
      <ButtonWithIcon
        name={`buy-product-${productId}-${mobile ? 'mobile' : 'laptop'}`}
        disabled={!isAvailable}
        type="submit"
        icon={<IconCart />}
        {...iconButtonParams}
      >
        <Trans id="general.button.label.addToCart" />
      </ButtonWithIcon>
    </Form>
  )
}

CartForm.propTypes = {
  mountPoints: mountPointsType.isRequired,
  productId: string.isRequired,
  stockStatus: shape(StockStatusType).isRequired,
  mobile: bool,
  algoliaQueryId: string,
  prescriptionType: oneOf(AVAILABLE_PRESCRIPTION_TYPES.ALL),
  position: number,
  showProductDetailLink: bool,
  offerId: string,
}

CartForm.defaultProps = {
  mobile: false,
  position: null,
  prescriptionType: DOCUMENT_TYPE.NO_PRESCRIPTION,
  algoliaQueryId: null,
  showProductDetailLink: true,
  offerId: null,
}

export default withMountPoints(CartForm)
